module.exports = __webpack_public_path__ + "img/art-museum.f05e9256.svg";